exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-content[data-v-21aee18a] {\n  width: 250px;\n}\n.tooltip-trigger[data-v-21aee18a] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}", ""]);

// exports
